export const tzOffsetMinutes = new Date().getTimezoneOffset()

// é invertido, e.g. UTC-3 é 180 min (e não -180)
let h = Math.floor(Math.abs(tzOffsetMinutes / 60))
h = h.toString().padStart(2, '0')
let m = Math.abs(tzOffsetMinutes % 60)
m = m.toString().padStart(2, '0')
let prefix = tzOffsetMinutes > 0 ? '-' : ''

let suffix = tzOffsetMinutes == 180 ? ' (BRT)' : ''
export const tzSubtitle = `${prefix}${h}:${m}${suffix}`